import { FormattedMessage } from 'react-intl'
import { Modal } from 'semantic-ui-react'

import Button from '@/components/Button'
import messages from '@/pages/OrganizationToolbarsPage/AddEditModal/messages'

const Buttons = ({ isEdit, onClose, onSubmit }: any) => {
  return (
    <Modal.Actions>
      <div className="modal-buttons">
        {isEdit ? (
          <>
            <Button
              color="tertiary"
              onClick={() => {
                onClose()
              }}
            >
              <FormattedMessage {...messages.cancel} />
            </Button>

            <Button
              color="primary"
              onClick={() => {
                onSubmit()
              }}
            >
              <FormattedMessage {...messages.updateAndClose} />
            </Button>
          </>
        ) : (
          <Button
            color="primary"
            className="credentials-button"
            onClick={() => {
              onSubmit()
            }}
          >
            <FormattedMessage {...messages.generateCredentials} />
          </Button>
        )}
      </div>
    </Modal.Actions>
  )
}

export default Buttons
